import objectPath from 'object-path'
import { getCurrentUi } from 'designer/component/action/Data'
import { getFormGroup } from 'designer/component/action/FormGroup'
import {
  clearFormStorage,
  getResetKeyList,
  resetKey,
} from 'designer/component/element/button/ButtonAction'
import { getFormGroupResetKeyList } from 'designer/component/element/button/ResetFormGroup'

const getRuleResetTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleResetUi = (designContext = {}, key = '') => {
  let { jsonForm = {} } = designContext
  return designContext.getCurrentUi
    ? designContext.getCurrentUi(key)
    : getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
}

const resetRuleAll = (
  designContext = {},
  formData = {},
  data = {},
) => {
  let {
    jsonForm = {},
    setDesignerPropsData,
    setAllData,
    setIsResetData,
    setFormData,
    setSearchData,
    setDatasourceValue,
    isUiChanged = {},
    setIsUiChanged,
  } = designContext
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}

  formData = resetKey({
    keyList: getResetKeyList(jsonForm),
    formData: {},
    designContext,
  })
  clearFormStorage(jsonForm)
  objectPath.set(designerPropsData, 'data', {})
  objectPath.set(designerPropsData, 'isReset', true)
  if (setDesignerPropsData) setDesignerPropsData(designerPropsData)
  if (setAllData) setAllData({})
  if (setSearchData) setSearchData({})
  if (setDatasourceValue) setDatasourceValue({})
  objectPath.set(isUiChanged, 'autocompleteOption', {})
  objectPath.set(isUiChanged, 'isResetAll', true)
  if (setIsUiChanged) setIsUiChanged(isUiChanged)
  if (setIsResetData) setIsResetData(true)
  if (setFormData) setFormData(formData)

  return formData
}

const resetRuleFormGroup = (
  designContext = {},
  action = {},
  formData = {},
) => {
  let { jsonForm = {}, setFieldFormData } = designContext
  let allFormGroup = getFormGroup(designContext)
  let form = allFormGroup.find(({ key }) => key === action.formDataKey) || {}
  let {
    isGroup,
    groupData = [],
    mapParam = {},
    mapArray = {},
  } = form
  let paramList = Object.keys(mapParam)

  paramList.forEach((key) => {
    let isArray = objectPath.get(mapArray, key)
    if (!isArray) return

    let ui = getRuleResetUi(designContext, key)
    if (ui.key !== key) return

    let { elements = [] } = ui
    elements.forEach((mainElement) => {
      let name = mainElement.name
      if (mainElement.tagname === 'panel') {
        name = `@${name}`
      }
      objectPath.del(formData, name)
      objectPath.del(formData, `@isCheckedAll.${name}`)
    })
  })

  if (isGroup) {
    groupData.forEach((group) => {
      formData = resetKey({
        keyList: getFormGroupResetKeyList(group),
        formData,
        designContext,
      })
    })
  } else {
    formData = resetKey({
      keyList: getFormGroupResetKeyList(form),
      formData,
      designContext,
    })
  }

  if (setFieldFormData) {
    objectPath.set(jsonForm, 'formData', formData)
  }

  return formData
}

const resetRulePanelGroup = (
  designContext = {},
  ui = {},
  formData = {},
) => {
  let { setFieldFormData } = designContext
  let panelElements = ui.elements || []

  panelElements.forEach(({ name }) => {
    if (objectPath.has(formData, `@${name}`) && setFieldFormData) {
      setFieldFormData(`@${name}`, undefined)
    }
    if (
      objectPath.has(formData, `@isCheckedAll.@${name}`) &&
      setFieldFormData
    ) {
      setFieldFormData(`@isCheckedAll.@${name}`, undefined)
    }
  })
}

const resetRuleGroup = (designContext = {}) => {
  let {
    jsonForm = {},
    setFieldSearchData,
  } = designContext
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}

  Object.keys(mapKey).forEach((mapItemKey) => {
    let fullKey = mapKey[mapItemKey]
    let keyList = String(fullKey || '').split('.')
    if (!keyList.includes(mapItemKey)) return

    let ui = getCurrentUi(mapItemKey, jsonForm.schema, jsonForm.uischema)
    if (ui.key !== mapItemKey || ui.uiType !== 'element') return
    if (!setFieldSearchData) return

    setFieldSearchData(ui, mapItemKey, undefined)
    setFieldSearchData(ui, ui.name, undefined)
  })
}

const resetRuleElement = (
  designContext = {},
  formData = {},
  data = {},
  targetKey = '',
) => {
  let {
    isUiChanged = {},
    setIsUiChanged,
    setFieldFormData,
    setFieldSearchData,
  } = designContext
  let ui = getRuleResetUi(designContext, targetKey)
  if (ui?.key !== targetKey) return formData

  objectPath.set(formData, targetKey, undefined)
  objectPath.set(formData, ui.name, undefined)
  if (data.isPage === 1) {
    if (setFieldSearchData) {
      setFieldSearchData(ui, targetKey, undefined)
      setFieldSearchData(ui, ui.name, undefined)
    }
  } else if (setFieldFormData) {
    setFieldFormData(targetKey, undefined)
    setFieldFormData(ui.name, undefined)
  }
  objectPath.set(isUiChanged, [targetKey, 'isRender'], true)
  objectPath.set(
    isUiChanged,
    [targetKey, 'isUnSelectRow'],
    data?.isUnSelectRow,
  )
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  if (ui.tagname === 'panelGroup') {
    resetRulePanelGroup(designContext, ui, formData)
  } else if (ui.type === 'Group') {
    resetRuleGroup(designContext)
  }

  return formData
}

const resetRuleResponse = (
  designContext = {},
  formData = {},
  targetKey = '',
) => {
  let { setFormData, setDatasourceValue } = designContext
  let [apiKey] = String(targetKey || '').split('.')
  let datasourceValue = objectPath.get(designContext, '@datasource') || {}

  objectPath.del(formData, `@response.${targetKey}`)
  objectPath.del(datasourceValue, apiKey)
  if (setFormData) setFormData(formData)
  if (setDatasourceValue) setDatasourceValue(datasourceValue)

  return formData
}

export const onRuleReset = (
  designContext = {},
  action = {},
  data = {},
  options = {},
) => {
  let {
    setRuleFormData = () => undefined,
    target = '',
  } = options
  let { jsonForm = {} } = designContext
  let formData = data.formData || jsonForm.formData || {}
  let targetKey = getRuleResetTarget(action, target)
  let { resetType, valueKey, groupType, isElement } = action
  let ui = getRuleResetUi(designContext, targetKey)

  if (resetType === 'all' || valueKey === 'all') {
    return resetRuleAll(designContext, formData, data)
  }
  if (resetType === 'formGroup') {
    return resetRuleFormGroup(designContext, action, formData)
  }
  if (isElement || ui?.key === targetKey) {
    return resetRuleElement(designContext, formData, data, targetKey)
  }
  if (groupType === 'response') {
    return resetRuleResponse(designContext, formData, targetKey)
  }

  if (!targetKey) return undefined

  setRuleFormData(designContext, targetKey, '')
  return ''
}
